export const TRANSLATIONS_ES = {
    login_login: 'Ingresar',
    login_username: 'Usuario',
    login_password: 'Contraseña',
    login_remember_me: 'Recuerdeme',
    login_forgot_pass: 'Olvido su password?',
    login_noaccount: 'Cerrar Sesion',
    record_updated_successfully: '{{table}} Actualizado exitosamente!',
    record_created_successfully: '{{table}} Creado exitosamente!',
    cash_form_cash_id: 'Caja ID',
    cash_form_lbl_cash_amount_open: 'Monto Apertura',
    cash_form_lbl_cash_description: 'Descripcion',
    cash_form_lbl_cash_date_opened: 'Fecha Apertura',
    cash_form_lbl_cash_amount_close: 'Monto Cierre',
    save_form_button: 'Guardar',
    update_form_button: 'Actualizar',
    record_deleted_success: 'Registro eliminado con exito!',
    delete_record_question: 'Esta seguro de eliminar el registro?',
    sure_to_delete_record_question: 'Esta seguro de eliminar el registro?',
    cash_table_title: 'Caja',
    form_table_column_date: 'Fecha',
    form_table_column_date_open: 'F.Apertura',
    form_table_column_amount_open: 'M.Apertura',
    form_table_column_description: 'Desc.',
    form_table_column_date_closed: 'F.Cierre',
    form_table_column_amount_close: 'M.Cierre',
    form_table_column_status: 'Edo.',
    detail_edit_record_tip: 'Editar Registro',
    detail_delete_record_tip: 'Eliminar Registro',
    detail_print_record_tip: 'Imprimir Factura',
    should_pick_a_product: 'Debe seleccionar un producto',
    invoice_form_detail_lbl_product: 'Producto',
    invoice_form_detail_lbl_qtty: 'Cant.',
    invoice_form_detail_lbl_price: 'Precio',
    invoice_form_detail_lbl_total: 'Total',
    invoice_form_detail_product: 'Producto',
    invoice_form_detail_qtty: 'Cant.',
    invoice_form_detail_price: 'Precio',
    invoice_form_detail_total: 'Total',
    client_form_lbl_client_name: 'Nombre',
    client_form_lbl_client_phone: 'Telefono',
    client_form_lbl_client_email: 'Email',
    client_form_lbl_client_website: 'Web',
    client_form_lbl_client_dnicuil: 'DNI/CUIL/CUIT',
    client_form_lbl_client_address: 'Direccion',
    client_form_lbl_client_state: 'Estado/Provincia',
    client_form_lbl_client_city: 'Ciudad',
    client_form_lbl_client_zip: 'CP',
    client_table_title: 'Cliente',
    client_table_column_name: 'Nombre',
    client_table_column_phone: 'Telefono',
    client_table_column_email: 'Email',
    client_table_column_address: 'Direccion',
    fill_all_fields_msg: 'Complete todos los campos por favor!',
    client_document_form_client_document_id: 'Documento ID',
    client_document_form_lbl_client_document_type: 'Typo de Documento',
    client_document_form_lbl_client_document_document: 'Documento',
    client_document_form_lbl_client_document_client: 'Cliente',
    invoice_form_lbl_invoice_employee: 'Empleado',
    invoice_form_lbl_invoice_affect_inventory: 'Afecta Inventario',
    invoice_form_lbl_invoice_body_note: 'Nota Superior',
    invoice_form_lbl_invoice_foot_note: 'Nota al Pie',
    invoice_form_lbl_invoice_discount: 'Descuento (%)',
    invoice_form_lbl_invoice_tax: 'Impuesto (%)',
    record_processed_success: 'Registro procesado con exito',
    invoice_record_question: 'Facturar documento',
    sure_to_invoice_record_question: 'Seguro ded facturar documento?',
    client_document_table_title: 'Documentos de cliente',
    form_table_column_document_type: 'Tipo.Doc',
    form_table_column_document: 'Numero',
    form_table_column_client: 'Cliente',
    form_table_column_subtotal: 'S.Total',
    form_table_column_discount: 'Dcto',
    form_table_column_tax: 'IVA',
    form_table_column_total: 'Total',
    detail_invoice_record_tip: 'Facturar documento',
    collect_form_collect_id: 'Cobro ID',
    collect_form_lbl_collect_invoice: 'Factura',
    collect_form_lbl_collect_description: 'Descripcion',
    collect_form_lbl_collect_total: 'Total',
    collect_table_title: 'Cobros',
    form_table_column_invoice: 'Factura',
    should_pick_a_paymentMethod: 'Debe seleccionar un metodo de pago',
    collect_form_detail_lbl_detail: 'Detalle',
    collect_form_detail_lbl_paymentMethod: 'F. Pago',
    collect_form_detail_lbl_bank: 'Banco',
    collect_form_detail_lbl_amount: 'Monto',
    collect_form_detail_lbl_reference: 'Referencia',
    collect_form_detail_payment_method: 'F.Pago',
    collect_form_detail_bank: 'Banco',
    collect_form_detail_amount: 'Monto',
    collect_form_detail_reference: 'Ref.',
    collect_form_detail_lbl_total_invoice: 'Total factura',
    collect_form_detail_lbl_total_collected: 'Cobrado',
    collect_form_detail_lbl_missing_to_collect: 'Resta',
    invoice_form_invoice_id: 'Factura ID',
    invoice_form_lbl_invoice_invoice: 'Factura',
    invoice_form_lbl_invoice_client: 'Cliente',
    invoice_table_title: 'Factura',
    form_table_column_collected: 'Cobrado',
    form_table_column_payed: 'Pagado',
    header_goToDoc: 'Documentacion',
    main_website: 'todocasero.ar',
    menu_process: 'Principal',
    menu_authenticate: 'Autenticacion',
    menu_invoice: 'Facturacion',
    menu_purchase: 'Compras',
    menu_cash: 'Caja',
    menu_inventory: 'Inventario',
    menu_tables: 'Tablas',
    menu_client: 'Clientes',
    menu_provider: 'Proveedores',
    menu_product_category: 'Categoria de Productos',
    menu_product: 'Productos',
    menu_employee: 'Empleados',
    menu_report: 'Reportes',
    menu_report_sales: 'Ventas',
    menu_report_purchase: 'Compras',
    menu_report_cash: 'Caja',
    menu_report_inventory: 'Inventario',
    menu_setting: 'Configuracion',
    menu_settings: 'Sistema',
    menu_users: 'Usuarios',
    menu_permissions: 'Permisos',
    menu_sales: 'Ventas',
    menu_collect: 'Cobros',
    menu_inventory_move: 'Movimientos',
    menu_cash_move: 'Principal',
    menu_cash_aux_move: 'Auxiliar',
    menu_purchases: 'Compras',
    menu_payment_method: 'Metodos de Pago/Cobro',
    product_form_lbl_category: 'Categoria',
    product_form_lbl_prod_code: 'Codigo',
    product_form_lbl_prod_name: 'Nombre',
    product_form_lbl_prod_format: 'Presentacion',
    product_form_lbl_prod_price: 'Precio',
    product_form_lbl_dct: 'Descuento',
    product_form_lbl_tax: 'Impuesto',
    product_form_lbl_barcode: 'Codigo de Barras',
    product_form_lbl_stock: 'Existencia',
    product_form_lbl_cost: 'Costo',
    product_form_lbl_prtype: 'Tipo de Nomina',
    product_table_title: 'Producto',
    product_table_column_code: 'Codigo',
    product_table_column_name: 'Nombre',
    product_table_column_category: 'Categoria',
    product_table_column_format: 'Presentacion',
    product_table_column_price: 'Precio',
    product_table_column_stock: 'Existencia',
    product_category_table_title: 'Categorias de Producto',
    product_category_table_column_name: 'Nombre',
    provider_form_lbl_provider_name: 'Nombre',
    provider_form_lbl_provider_phone: 'Telefono',
    provider_form_lbl_provider_email: 'Email',
    provider_form_lbl_provider_website: 'Web',
    provider_form_lbl_provider_dnicuil: 'DNI/CUIL/CUIT',
    provider_form_lbl_provider_address: 'Direccion',
    provider_form_lbl_provider_state: 'Estado/Provincia',
    provider_form_lbl_provider_city: 'Ciudad',
    provider_form_lbl_provider_zip: 'CP',
    provider_table_title: 'Proveedores',
    provider_table_column_name: 'Nombre',
    provider_table_column_phone: 'Telefono',
    provider_table_column_email: 'Email',
    provider_table_column_address: 'Direccion',
    purchase_form_purchase_id: 'Compra ID',
    purchase_form_detail_lbl_product: 'Producto',
    purchase_form_detail_lbl_qtty: 'Cant.',
    purchase_form_detail_lbl_price: 'Precio',
    purchase_form_detail_lbl_total: 'Total',
    purchase_form_detail_product: 'Producto',
    purchase_form_detail_qtty: 'Cant.',
    purchase_form_detail_price: 'Precio',
    purchase_form_detail_total: 'Total',
    purchase_form_lbl_purchase_purchase: 'Compra Nro',
    purchase_form_lbl_purchase_provider: 'Proveedor',
    purchase_form_lbl_purchase_employee: 'Empleado',
    purchase_form_lbl_purchase_body_note: 'Notal Superior',
    purchase_form_lbl_purchase_foot_note: 'Nota al Pie',
    purchase_form_lbl_purchase_discount: 'Descuento (%)',
    purchase_form_lbl_purchase_tax: 'Impuesto(%)',
    purchase_table_title: 'Compras',
    form_table_column_purchase: 'Compra',
    form_table_column_due_date: 'F.Vcmto.',
    form_table_column_amount: 'Monto',
    form_table_column_affects_cash: 'Afecta Caja',
    menu_client_document: 'Documentos',
    payment_method_table_title: 'Formas de Pago',
    cash_form_detail_lbl_concept: 'Concepto',
    cash_form_detail_lbl_amount: 'Monto',
    cash_form_detail_concept: "Concepto",
    cash_form_detail_amount: "Monto",
    cash_form_lbl_cash_date_closed: "Fecha Cierre",
    cash_form_lbl_invoice_is_closed: "Cerrada",
    cash_form_lbl_invoice_to_close: "Cerrar?",
    cash_form_lbl_cash_name: "Nombre de la caja",
    cash_form_lbl_cash_user: "Usuario crea/modif.",
    cash_form_lbl_cash_date_created: "Fecha Creacion",
    cash_form_lbl_cash_date_modified: "Fecha Modificacion",
    cash_form_lbl_cash_aux_select: "Seleccionar caja",
    cash_form_cash_aux_id: "Aux. ID",
    form_table_column_user: "Usuario",
    inventory_form_lbl_inventory_description: "Desccripcion",
    inventory_table_title: "Inventario",
    inventory_form_inventory_id: "Inventario ID",
    inventory_form_detail_lbl_qtty: "Cant-",
    inventory_form_detail_lbl_concept: "Concep.",
    inventory_form_detail_qtty: "Cant.",
    inventory_form_detail_concept: "Concep.",
    report_inventory_valorized_title: "Inventario Valorizado",
    report_inventory_valorized_title2: "Inventario Valorizado2",
    report_form_detail_lbl_selected_report: "Reporte seleccionado",
    report_form_lbl_date_from: "Fecha desde",
    report_form_lbl_date_to: "Fechas hasta",
    report_form_lbl_from_data: "Valor desde",
    report_form_lbl_to_data: "Valor Hasta",
    send_form_button: "Enviar",
    configuration_form_title_update: "Actualizar Configuracion",
    configuration_form_title_create: "Crear Configuratcion",
    configuration_form_lbl_config_name: "Nombre",
    configuration_form_lbl_config_value: "Valor",
    configuration_table_title: "Configuracion listado",
    configuration_table_column_name: "Nombre",
    configuration_table_column_value: "Valor",
    menu_configuration_move: "Configuration",
    menu_configuration: "Configuration",
    payment_form_detail_lbl_detail: "Detalle",
    payment_form_detail_lbl_paymentMethod: "F.Pago",
    payment_form_detail_lbl_bank: "Banco",
    payment_form_detail_lbl_amount: "Monto",
    payment_form_detail_lbl_reference: "Refencia",
    payment_form_detail_payment_method: "F.PAgo",
    payment_form_detail_bank: "Banco",
    payment_form_detail_amount: "Monto",
    payment_form_detail_reference: "Refencia",
    payment_form_detail_lbl_total_purchase: "Total Compra",
    payment_form_detail_lbl_total_paymented: "Total Pagado",
    payment_form_detail_lbl_missing_to_payment: "Diferencia",
    payment_form_payment_id: "ID",
    payment_form_lbl_payment_purchase: "Compra",
    payment_form_lbl_payment_description: "Descripcion",
    payment_form_lbl_payment_total: "Total",
    form_table_column_provider: "Proveedor",
    payment_table_title: "Pagos - Movimientos",
    menu_payment: "Pagos",
    print_form_button: "Imprimir",
    error_msg_unauthorized: "La sesion expiró, ingrese de nuevo las credenciales!",
    menu_user_permission: "Permisos de Usuario",
    permission_table_title: "Permisos",
    permission_table_column_user_name: "Usuario",
    permission_table_column_path: "Opcion",
    permission_table_column_can_list: "Listar",
    permission_table_column_can_get: "Consultar",
    permission_table_column_can_post: "Crear",
    permission_table_column_can_patch: "Actualizar",
    permission_table_column_can_delete: "Borrar",
    permission_form_lbl_invoice_user_id: "Usuario",
    permission_form_lbl_path: "Opcion",
    permission_form_lbl_invoice_can_list: "Listar",
    permission_form_lbl_invoice_can_get: "Consultar",
    permission_form_lbl_invoice_can_post: "Crear",
    permission_form_lbl_invoice_can_patch: "Actualizar",
    permission_form_lbl_invoice_can_delete: "Borrar",
    bank_table_title: "Bancos",
    bank_table_column_name: "Nombre",
    menu_bank: "Bancos",
    document_type_table_title: "Listado",
    document_type_table_column_name: "Nombre",
    document_type_table_column_code: "Codigo",
    menu_document_type: "Tipos de Documento",
    user_table_title: "Listado",
    user_table_column_user_name: "Usuario",
    user_table_column_first_name: "Nombre",
    user_table_column_last_name: "Apellido",
    user_table_column_email: "Email",
    user_table_column_is_active: "Activo",
    user_table_column_is_staff: "Empleado",
    user_table_column_is_superuser: "Admin",
    user_form_lbl_username: "Usuario",
    user_form_lbl_first_name: "Nombre",
    user_form_lbl_last_name: "Apellido",
    user_form_lbl_email: "Email",
    user_form_lbl_password: "Password",
    user_form_lbl_confirm_password: "Confirme Password",
    user_form_lbl_invoice_is_active: "Activo?",
    user_form_lbl_invoice_is_staff: "Empleado?",
    user_form_lbl_invoice_is_superuser: "Admin?",
    menu_payroll: "Nomina",
    profesional_table_title: "Listado",
    profesional_table_column_name: "Nombres",
    profesional_table_column_phone: "Telefono",
    profesional_table_column_email: "Email",
    profesional_form_lbl_profesional_name: "Nombres",
    profesional_form_lbl_profesional_phone: "Telefono",
    profesional_form_lbl_profesional_comision: "Comision",
    profesional_form_lbl_profesional_email: "Email",
    profesional_form_lbl_profesional_gender: "Genero",
    profesional_form_lbl_profesional_dni: "DNI",
    profesional_form_lbl_profesional_cuil: "Cuil",
    profesional_form_lbl_profesional_address: "Direccion",
    profesional_form_lbl_profesional_city: "Ciudad",
    profesional_form_lbl_profesional_state: "Provincia",
    profesional_form_lbl_profesional_zip: "C.P.",
    menu_pr_type: "Tipo Nomina",
    pr_type_table_title: "Listado",
    pr_type_table_column_code: "Codigo",
    pr_type_table_column_name: "Nombre",
    pr_type_table_column_concept_list: "Conceptos",
    pr_type_table_column_period: "Nro. de Dias",
    profesional_form_lbl_profesional_work_hours: "Horas de Trabajo",
    profesional_form_lbl_profesional_salary: "Salario",
    menu_pr_concept: "Conceptos",
    pr_concept_table_title: "Listado",
    pr_concept_table_column_code: "Codigo",
    pr_concept_table_column_name: "Nombre",
    pr_concept_table_column_expression: "Expresion",
    menu_employee_move: "Movimientos de Empleado",
    pr_employee_move_table_title: "Listado",
    pr_employee_move_table_column_effective_date: "Fecha Efectiva",
    pr_employee_move_table_column_employee: "Empleado",
    pr_employee_move_table_column_concept: "Concepto",
    pr_employee_move_table_column_description: "Descripcion",
    pr_employee_move_table_column_allowance: "Asign.",
    pr_employee_move_table_column_deduction: "Deduc.",
    pr_employee_move_form_concept: "Concepto",
    pr_employee_move_form_employee: "Empleado",
    payroll_table_title: "Listado",
    form_table_column_payment_date: "F.Pago",
    form_table_column_type: "Tipo",
    form_table_column_notes: "Notas",
    form_table_column_message: "Mensaje",
    payroll_form_payroll_id: "Nomina",
    payroll_form_detail_lbl_product: "33",
    payroll_form_detail_lbl_qtty: "33",
    payroll_form_detail_lbl_price: "33",
    payroll_form_detail_lbl_total: "33",
    payroll_form_lbl_payroll_payroll: "33",
    payroll_form_lbl_payroll_tax: "33",
    payroll_form_lbl_payroll_pr_type: "Tipo Nomina",
    payroll_form_lbl_payroll_notes: "Nota Interna",
    payroll_form_lbl_payroll_message: "Mensaje al Empleado",
    payroll_form_detail_employee: "Empleado",
    payroll_form_detail_concept: "Concepto",
    payroll_form_detail_description: "Descripcion",
    payroll_form_detail_allowance: "Asign.",
    payroll_form_detail_deduction: "Deduc.",
    detail_print_payslip_tip: "Imprimir Recibos",
    error_cash_aux_not_selected: "Debe seleccionar una caja auxiliar",
    error_cash_aux_selected: "No puede haber una caja auxiliar seleccionada",
    error_cash_aux_with_moves: "Asegurese que la caja no tenga movimientos",
    dialog_cash_aux_delete_record: "Desea eliminar el registro?",
    cash_aux_detail_affects_cash: "Afecta Caja?",
    cash_form_lbl_cash_amount: "Monto",
    cash_form_lbl_cash_concept: "Concepto",
};
